import { CANCELLATION_TEXT, TERMS_TEXT } from '../constants/formConfig';
import { calculateTotals, formatCurrency } from '../utils/pricing';
import { Field } from './Field';
import { StripePayment } from './StripePayment';

export function TermsAndPayment({ form, errors, onChange, paymentRef }) {
  const schoolName = form.school?.name?.trim() || 'your school';
  const totals = calculateTotals(form.students || []);

  return (
    <>
      <section className="section">
        <h2 className="section-title">Terms and Conditions</h2>
        <div className="policy-box">{TERMS_TEXT}</div>
        <Field error={errors.acceptTerms}>
          <label className="checkbox-option checkbox-wide">
            <input
              type="checkbox"
              checked={form.acceptTerms}
              onChange={(e) => onChange({ acceptTerms: e.target.checked })}
            />
            <span>
              I have read, understood, and hereby accept the Terms and Conditions
              and attest that I have permission to do so on behalf of{' '}
              <strong>{schoolName}</strong>.
              <span className="req">*</span>
            </span>
          </label>
        </Field>
      </section>

      <section className="section">
        <h2 className="section-title">Cancellation Policy</h2>
        <div className="policy-box">{CANCELLATION_TEXT}</div>
        <Field error={errors.acceptCancellation}>
          <label className="checkbox-option checkbox-wide">
            <input
              type="checkbox"
              checked={form.acceptCancellation}
              onChange={(e) =>
                onChange({ acceptCancellation: e.target.checked })
              }
            />
            <span>
              I have read and understand the cancellation policy.
              <span className="req">*</span>
            </span>
          </label>
        </Field>
      </section>

      <section className="section">
        <h2 className="section-title">Amount Due — Payment</h2>

        <div className="totals-box">
          <div className="totals-row">
            <span>Student fees ({formatCurrency(totals.perTest)}/test)</span>
            <span>{formatCurrency(totals.studentFees)}</span>
          </div>
          <div className="totals-row grand">
            <span>Amount due</span>
            <span>{formatCurrency(totals.total)}</span>
          </div>
        </div>

        <StripePayment
          ref={paymentRef}
          amountCents={Math.round(totals.total * 100)}
          testCount={totals.testCount}
          studentCount={totals.studentCount}
          metadata={{
            schoolCode: form.school.schoolCode,
            schoolName: form.school.name,
          }}
        />
      </section>
    </>
  );
}
